import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="pt-[60px] md:pt-[80px] lg:pt-[100px] xl:pt-[150px] border-t border-gray-100 dark:border-[#172036]">
        <div className="container 2xl:max-w-[1320px] mx-auto px-[12px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[25px]">
            <div className="ltr:xl:-mr-[35px] rtl:xl:-ml-[35px]">
              <Link
                to="/"
                className="inline-block max-w-[132px] mb-[20px] md:mb-[23px]"
              >
                <img
                  src="/images/logo-big.svg"
                  alt="logo"
                  className="inline-block dark:hidden"
                  width={132}
                  height={53}
                />
                <img
                  src="/images/white-logo-big.svg"
                  alt="logo"
                  className="hidden dark:inline-block"
                  width={132}
                  height={53}
                />
              </Link>

              <p className="leading-[1.6]">
                {t("landing.footer.description")}
              </p>

              <div className="mt-[20px] md:mt-[35px]">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="https://x.com/?lang=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0"
                >
                  <i className="ri-twitter-x-fill"></i>
                </a>
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>

            <div className="ltr:xl:pl-[142px] rtl:xl:pr-[142px]">
              <h3 className="!leading-[1.2] !text-[16px] md:!text-lg !mb-[18px] !font-semibold">
                {t("landing.footer.ourModules")}
              </h3>
              <ul>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/dashboard"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.hrManagement")}
                  </Link>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/dashboard"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.financePayroll")}
                  </Link>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/dashboard"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.crmProjects")}
                  </Link>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/dashboard"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.workflowDocuments")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="ltr:xl:pl-[130px] rtl:xl:pr-[130px]">
              <h3 className="!leading-[1.2] !text-[16px] md:!text-lg !mb-[18px] !font-semibold">
                {t("landing.footer.quickLinks")}
              </h3>
              <ul>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("navbar.home")}
                  </Link>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/#features"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("navbar.features")}
                  </Link>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/sign-in"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("navbar.login")}
                  </Link>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <Link
                    to="/sign-up"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("navbar.register")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="ltr:xl:pl-[80px] rtl:xl:pr-[80px]">
              <h3 className="!leading-[1.2] !text-[16px] md:!text-lg !mb-[18px] !font-semibold">
                {t("landing.footer.support")}
              </h3>
              <ul>
                <li className="mb-[10px] last:mb-0">
                  <a
                    href="#"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.documentation")}
                  </a>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <a
                    href="#"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.helpCenter")}
                  </a>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <a
                    href="#"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.contactUs")}
                  </a>
                </li>
                <li className="mb-[10px] last:mb-0">
                  <a
                    href="#"
                    className="lg:text-[16px] inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
                  >
                    {t("landing.footer.privacyPolicy")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-[15px] md:py-[20px] mt-[60px] md:mt-[80px] lg:mt-[100px] bg-white dark:bg-[#0c1427] text-center">
          <div className="container 2xl:max-w-[1320px] mx-auto px-[12px]">
            <p className="leading-[1.6]">
              {t("landing.footer.copyright")}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;

